import { render, staticRenderFns } from "./WidgetController.vue?vue&type=template&id=53fe319b"
import script from "./WidgetController.vue?vue&type=script&lang=js"
export * from "./WidgetController.vue?vue&type=script&lang=js"
import style0 from "./WidgetController.vue?vue&type=style&index=0&id=53fe319b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports